export default __webpack_public_path__ + "static/media/customer-diamond.b08723ca.jpg";